export default __webpack_public_path__ + "static/media/Linear.115b3577.svg";